import * as React from 'react';
import { compose, withHandlers, withProps } from 'recompose';
import { TranslateProps } from 'util/i18n';
import { translate } from 'react-i18next';
import { skin, OemProps } from 'ui/styles/skin';
import * as moment from 'moment';
import { InstantMessage as InstantMessageType, InstantMessageId } from 'types';
import { X } from 'ui/shapes';

const audioSrc = require('assets/audio/instant-message-received.mp3');

const SYSTEM_SENDER = '___$System$___';

export type OwnProps = InstantMessageType & {
    onClickClose: (id: InstantMessageId) => void;
};

const RawInstantMessage = ({ id, senderName, text, utcTime, handleClickClose, styles, t }: OwnProps & RecomposeProps & OemProps & TranslateProps) =>
    <div
        className="instant-message"
        style={ styles.IMWindow }
    >
        <div className="im-sender">
            { senderName === SYSTEM_SENDER ? t('6.1240.4411') : senderName }
        </div>
        <div
            className="im-text"
            style={ styles.Quote }
        >
            { text }
        </div>
        <div className="im-timestamp">
            { moment.utc(utcTime).format('LTS') }
        </div>
        <span
            id={ `im${id}-close` }
            className="im-close"
            onClick={ handleClickClose }
            tabIndex={ 0 }
            style={ styles.Bordered }

        >
            <X width=".5em" height=".5em" style={ styles.FillForeground }/>
        </span>

        { /* Play a sound when an instant message is mounted */ }
        <audio
            src={ audioSrc }
            autoPlay={ true }
        />
    </div>
;

type RecomposeProps = {
    handleClickClose: React.MouseEventHandler<HTMLElement>;
};

export const InstantMessage = compose<OwnProps & RecomposeProps & OemProps & TranslateProps, OwnProps>(
    skin,
    translate(),
    withHandlers<OwnProps, RecomposeProps>({
        handleClickClose: ({ id, onClickClose }) => (e: React.MouseEvent<HTMLElement>) => {
            onClickClose(id);
        },
    }),
    withProps(({ styles }) => ({
        styles: {
            ...styles,
            IMWindow: {
                ...styles.Bordered,
                ...styles.Window,
            },
            Quote: {
                borderLeft: `solid .5em ${styles.Accent.backgroundColor}`,
                paddingLeft: '.5em',
            },
        },
    })),
)(RawInstantMessage);



// WEBPACK FOOTER //
// ./src/ui/main/InstantMessage.tsx